var ItemTypeV1 = /* @__PURE__ */ ((ItemTypeV12) => {
  ItemTypeV12["SINGLE_LINE"] = "single-line";
  ItemTypeV12["MULTI_LINE"] = "multi-line";
  ItemTypeV12["HOTSPOT"] = "hotspot";
  ItemTypeV12["IMAGE"] = "image";
  return ItemTypeV12;
})(ItemTypeV1 || {});
var HotspotTypeV1 = /* @__PURE__ */ ((HotspotTypeV12) => {
  HotspotTypeV12["SPEECH"] = "speech";
  HotspotTypeV12["LINK"] = "link";
  return HotspotTypeV12;
})(HotspotTypeV1 || {});
var HotspotIconPositionsV1 = /* @__PURE__ */ ((HotspotIconPositionsV12) => {
  HotspotIconPositionsV12["TOP_LEFT"] = "top-left";
  HotspotIconPositionsV12["TOP_RIGHT"] = "top-right";
  HotspotIconPositionsV12["BOTTOM_LEFT"] = "bottom-left";
  HotspotIconPositionsV12["BOTTOM_RIGHT"] = "bottom-right";
  return HotspotIconPositionsV12;
})(HotspotIconPositionsV1 || {});
function isSingleLineInputV1(input) {
  return input.type === "single-line" /* SINGLE_LINE */;
}

export { HotspotIconPositionsV1, HotspotTypeV1, ItemTypeV1, isSingleLineInputV1 };
//# sourceMappingURL=ItemV1.js.map
